import React,{Component} from 'react';
import './Aboutme.scss';
import "../../../node_modules/video-react/dist/video-react.css";
import Header from '../../components/Header';

class Aboutme extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sendMail: false,
      viewCv: false,
      ifeSelect: false
    };
  }

  componentDidMount() {
    this.scrollDown();
  }
  componentDidUpdate() {
    this.scrollDown();
  }

  scrollDown =() => {
    window.location.hash === "#/contact" &&
    window.scrollTo(0,document.body.scrollHeight);
  }

  render() {
    // let infoContact = [];
    // infoContact = this.state.infoContact && this.state.infoContact.indexOf("https") === -1 ?<span>{this.state.infoContact}</span> : <a href={this.state.infoContact}>{this.state.infoContact}</a> ;
    return (
      <div ref={(elm)=>{this.contentPres=elm;}} className={"ct-presentation"}>

        <Header pageActive={2} />

        <div className={"Aboutme-body jc-c"}>
          <div>
          <p>yes yes sounds good</p>

<p>Today Saturday June 3. Right now I'm starting to read the title to change the &quot;About me&quot; section on my linkedin as I'm once again looking for that next long incubating Challenge that has been waiting for me where I know I'm going! will unite us for years to come!!</p>

<p>I characterize myself for being disruptive in all aspects and facets of life,</p>

<p>What?, yes, it's me!!, What is the big problem? None!</p>

<p> <br />
It sure will be a Great Coincidence,</p>

<p> He needed me to do it! That great decision is part of the opportunity that I was experiencing and that you, dear reader, are experiencing.</p>

<p>Go ahead, read on as I'm still editing the about me section...</p>

<p>About me</p>

<p>You can write about your years of experience, industry... Blah, BlaH, BLAH&uml;&acute; I just want to tell you that life is AMAZING AND BEAUTIFUL.</p>

<p>Sign out, sign out, sign out!! &quot;THAT IS RUSH&quot; &quot;ONE MORE LIE&quot;</p>

<p>Remember that there are more important things, always remember to finish all the sessions and activities of your life. That? That? Yes, that is what I base myself on and that is that there will only be 1 more time of everything we do right now, only one more time.<br />
just one more time.</p>

<p>do you understand?</p>

<p>Yeah huh? ?, THAT ONLY YOU,</p>

<p>Dear READER, you must remember that the happiness of you and those around you is in your Wonderful Hands!</p>

<p>Do not allow anything or anyone to stop you... The way is to know how to receive adversity or the consequences of your things with HAPPINESS!]</p>

<p>The Purpose is very clear to me, the path is uncertain! I know you are not interested, but I face the road in my own way, My way is Living it with Happiness, of course with many more sensations. many and many more.</p>

<p>But!! Being happy!</p>

<p>Assimilating that the experiences of this peculiar moment, place, time, space are the reflection of my thoughts, actions and decisions</p>

<p>Can you be happy? Can? Can you be a damn happy person, a happy son of a bitch?<br />
A happy person? Could it be that we can? ?? Can you be?, you who are knowing me...</p>

<p>I ask you, what if you YOU CAN BE HAPPY while you are living or facing an adverse situation, a problem, a shortage, a calamity, (whatever it is), you can be happy knowing and understanding that all that you are living, feeling, or perhaps facing is entirely yours. and sole responsibility? Can you be happy?</p>

<p>
Right now I don't know if I can, but it sounds good, or I don't know, but I think it's just a behavior that I'm forging, something that I'm provoking,</p>

<p>(( Continua leyendo en mi web por que he excedido el maximo de 2600 caracteres que tiene linkedin para el campo about me</p>

<p>&iexcl; ALWAYS BE FELIZ !.))</p>

<p>I am trying to be happy in all spaces and moments of my life. Lately, no matter how ruined or destroyed I feel, I try to Be A Sincerely Happy Person and to Transmit Happiness through all those frequencies that surround us!</p>

<p>HAPPY &quot;Happy Life&quot;<br />
 Long live Happy Cuch@&quot;!</p>

<p>HAPPY &quot;Happy 'any shit', any shit you want&quot;</p>

<p>I'll read it another time</p>

<p>...<br />
In another space I hope to be able to complement or change this section</p>

<p>It is of a high degree of satisfaction to know that I am writing this alive, now. Right now!.</p>

<p>Take care of yourself all the time, be the happiest person right now, right now that you live, take care. iS your responsabilitie always being a person who brings Happiness, that Convey Happiness, Come, Come to me</p>

<p>Come, come to me, energy come with me, Give me your Happiness that my sniffer is already at the oven door</p>

<p>&deg;&deg;&deg;<br />
Ahora en spanish</p>

<p>si si suena bien</p>

<p>Hoy s&aacute;bado 3 de junio. Ahora mismo estoy empezando a leer el t&iacute;tulo para cambiar la secci&oacute;n &quot;Acerca de m&iacute;&quot; en mi Linkedin ya que una vez m&aacute;s estoy buscando ese pr&oacute;ximo Reto que lleva mucho tiempo incubando y que me ha estado esperando donde s&eacute; que estoy. &iexcl;Voy! nos unir&aacute; en los a&ntilde;os venideros!!</p>

<p>Me caracterizo por ser disruptivo en todos los aspectos y facetas de la vida,</p>

<p>&iquest;Qu&eacute;?, &iexcl;s&iacute;, soy yo!, &iquest;cu&aacute;l es el gran problema? &iexcl;Ninguno!</p>

<p> <br />
Seguro que ser&aacute; una Gran Coincidencia,</p>

<p> &iexcl;&Eacute;l necesitaba que yo lo hiciera! Esa gran decisi&oacute;n es parte de la oportunidad que yo estaba viviendo y que usted, querido lector, est&aacute; viviendo.</p>

<p>Adelante, sigue leyendo porque todav&iacute;a estoy editando la secci&oacute;n acerca de m&iacute;...</p>

<p>Acerca de m&iacute;</p>

<p>Puedes escribir sobre tus a&ntilde;os de experiencia, industria... Blah, BlaH, BLAH&uml;&acute; Solo quiero decirte que la vida es INCRE&Iacute;BLE Y HERMOSA.</p>

<p>Cerrar sesi&oacute;n, cerrar sesi&oacute;n, cerrar sesi&oacute;n!! &quot;ESO ES PRISA&quot; &quot;UNA MENTIRA MAS&quot;</p>

<p>Recuerda que hay cosas m&aacute;s importantes, recuerda siempre terminar todas las sesiones y actividades de tu vida. &iquest;Eso? &iquest;Eso? S&iacute;, en eso me baso y es que solo habr&aacute; 1 vez m&aacute;s de todo lo que hacemos ahora mismo, solo una vez m&aacute;s.<br />
s&oacute;lo una vez m&aacute;s.</p>

<p>&iquest;lo entiendes?</p>

<p>S&iacute;, &iquest;eh? ?, QUE SOLO TU,</p>

<p>Querido LECTOR, debes recordar que la felicidad tuya y de los que te rodean est&aacute; en tus Maravillosas Manos!</p>

<p>No permitas que nada ni nadie te detenga... &iexcl;El camino es saber recibir la adversidad o las consecuencias de tus cosas con FELICIDAD!]</p>

<p>&iexcl;El Prop&oacute;sito es muy claro para m&iacute;, el camino es incierto! S&eacute; que no te interesa, pero afronto el camino a mi manera, Mi manera es Vivirla con Alegr&iacute;a, por supuesto con muchas m&aacute;s sensaciones. muchas y muchas m&aacute;s.</p>

<p>&iexcl;&iexcl;Pero!! &iexcl;Ser feliz!</p>

<p>Asimilando que las vivencias de este peculiar momento, lugar, tiempo, espacio son el reflejo de mis pensamientos, acciones y decisiones</p>

<p>&iquest;Puedes ser feliz? &iquest;Poder? &iquest;Puedes ser una persona malditamente feliz, un hijo de puta feliz?<br />
&iquest;Una persona feliz? &iquest;Ser&aacute; que podemos? ?? &iquest;Puedes ser?, t&uacute; que me est&aacute;s conociendo...</p>

<p>Te pregunto que tal si PUEDES SER FELIZ mientras est&aacute;s viviendo o enfrentando una situaci&oacute;n adversa, un problema, una escasez, una calamidad, (sea lo que sea), puedes ser feliz sabiendo y entendiendo que todo lo que est&aacute;s viviendo, sintiendo, o tal vez enfrentando, es enteramente tuyo. y es tu &uacute;nica responsabilidad? &iquest;Puedes ser feliz?</p>

<p>
Ahora mismo no s&eacute; si pueda, pero suena bien, o no s&eacute;, pero creo que es solo un comportamiento que estoy forjando, algo que estoy provocando,</p>

<p>&iexcl; SIEMPRE S&Eacute; FELIZ !.</p>

<p>Estoy tratando de ser feliz en todos los espacios y momentos de mi vida. &Uacute;ltimamente, por m&aacute;s arruinado o destruido que me sienta, intento Ser Una Persona Sinceramente Feliz y Transmitir Felicidad a trav&eacute;s de todas esas frecuencias que nos rodean!</p>

<p>FELIZ &quot;Vida feliz&quot;<br />
 &iexcl;Viva Feliz Cuch@&quot;!</p>

<p>FELIZ &quot;Feliz 'cualquier mierda', cualquier mierda que quieras&quot;</p>

<p>lo leer&eacute; en otro momento</p>

<p>...<br />
En otro espacio espero poder complementar o cambiar esta secci&oacute;n</p>

<p>Es de un alto grado de satisfacci&oacute;n saber que estoy escribiendo esto vivo, ahora. &iexcl;Ahora mismo!.</p>

<p>Cu&iacute;date todo el tiempo, s&eacute; la persona m&aacute;s feliz en este momento, en este momento que vives, cu&iacute;date. es tu responsabilidad ser siempre una persona que trae Felicidad, que Transmite Felicidad, Ven, Ven a mi</p>

<p>Ven, ven a m&iacute;, energ&iacute;a ven conmigo, dame tu felicidad que mi sniffer ya est&aacute; en la puerta del horno.</p>

<p>--</p>
          </div>

          {/* <div  className="Aboutme">
            <header onClick={this.fullScreen} className="Aboutme-header">
              <Player
                playsInline
                videoId="video-2">
                <source src="https://static.gaviria.org/presentation.mp4" />
              </Player>
            </header>
          </div> */}
          <div className="Aboutme">
            {/* <header className="Aboutme-header">
              <iframe title={"Torre Profile"} width={"100%"} height={window.innerHeight-100} src={this.state.ifeSelect ? "https://www.upwork.com/freelancers/~016fa1f065fad03dc8" : "https://bio.torre.co/es/cristiangaviria"}>
              </iframe>
            </header> */}
          </div>


          <div className="Aboutme">
            {/* <header>
              <div className="Aboutme-header fd-r">
                <div onClick={this.onShowCv} className={"ct-btn-cv"}>
                  <span className={"tx-btn-cv"}>CV</span>
                </div>
                <div onClick={()=>{this.sendMail()}} className={"ct-btn-cv"}>
                  <span className={"tx-btn-cv"}>Mail</span>
                </div>
                {
                  this.state.ifeSelect ?
                    <div onClick={()=>{
                      this.setState({infoContact:"https://bio.torre.co/es/cristiangaviria", ifeSelect: !this.state.ifeSelect})}
                    } className={"ct-btn-cv"}>
                      <span className={"tx-btn-cv"}>Torre</span>
                    </div>
                    :
                    <div onClick={()=>{
                      window.open("https://www.upwork.com/freelancers/~016fa1f065fad03dc8");
                      this.setState({infoContact:"https://www.upwork.com/freelancers/~016fa1f065fad03dc8"});

                    }
                    } className={"ct-btn-cv"}>
                      <span className={"tx-btn-cv"}>Uw</span>
                    </div>



                }
                <div onClick={()=>{
                  window.open("https://www.linkedin.com/in/cristiangaviria/");
                  this.setState({infoContact:"https://www.linkedin.com/in/cristiangaviria/", ifeSelect: !this.state.ifeSelect})}
                } className={"ct-btn-cv"}>
                  <span className={"tx-btn-cv"}>In</span>
                </div>

              </div>
              <div className={"sc-info"}>
                {infoContact}
              </div>
            </header> */}
          </div>
        </div>


        <footer className={"foot-page"}>
          
        <h6 className={"name-person"}><a rel="noopener noreferrer" target={"_blank"} href={"https://gaviria.org/#/terminos-y-condiciones"} > Términos y condiciones </a></h6>
        
          <h6 className={"name-person"}>Gaviria IT Services - <a rel="noopener noreferrer" target={"_blank"} href={"https://wa.me/573508010429"} > 57 350 801 0429</a></h6>

{/* 
          {this.state.viewCv ? <iframe ref={(elm) => {this.cvElm = elm;}} title={"Cv"} onClick={this.onShowCv}  className={"show-cv"}  width={"100%"} height={window.innerHeight}  src="https://gaviria.org/CV-CristianGaviria.pdf" frameBorder="0"></iframe> : []} */}
      
      
      <h6 className={"name-person"}> <a rel="noopener noreferrer" target={"_blank"} href={"https://gaviria.org/#/politica-de-privacidad"} > Política de privacidad </a></h6>
        </footer>
       
      </div>
    );
  }

  onShowCv = () => {
    if(this.cvElm) {
      this.cvElm.scrollTop = this.cvElm.scrollHeight;
      }
    this.setState({
      viewCv: !this.state.viewCv,
      infoContact:"Gaviria IT Services"
    });
  }

  sendMail = () => {
    window.open("mailto:cristian@gaviria.org");
    this.setState({
      infoContact: "cristian@gaviria.org"
    });
  }

  fullScreen =() =>{
    let elem  = document.getElementById("video-2");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  }

}

export default Aboutme;
